<template>
  <div class="devpage-page">
    <van-pull-refresh v-model="isLoading" @refresh="onReflash" class="devpage-index">
      <van-nav-bar left-arrow class="crystal-nav" @click-left="onClickLeft">
        <template #left>
          <van-icon name="arrow-left" size="20px" color="#475569" />
        </template>
        <template #title>
          <div class="nav-title-wrap">
            <span class="nav-devname">{{ devdata ? devdata.udname : 'KS-1 设备' }}</span>
            <span class="nav-did">{{ did }}</span>
          </div>
        </template>
      </van-nav-bar>

      <div v-if="devdata" class="content-area">

        <div class="status-button" :class="statusBtnClass" @click="toggleOutput">
          <div class="status-side-icon">
            <span class="iconfont icon-kaiguan"></span>
          </div>
          <div class="status-center">
            <div class="status-title">{{ statusTitle }}</div>
            <div class="status-subtitle">{{ statusSub }}</div>
          </div>
          <div class="status-badge">
            <span v-if="out === 1" class="badge-dot dot-on"></span>
            <span v-else class="badge-dot dot-off"></span>
          </div>
        </div>

        <div class="metrics-panel">
          <div class="metric-block">
            <div class="metric-icon-wrap">
              <span class="iconfont icon-dianya"></span>
            </div>
            <div class="metric-body">
              <span class="metric-label">电压</span>
              <div class="metric-value-row">
                <span class="metric-value">{{ volt != null ? volt.toFixed(2) : '--' }}</span>
                <span class="metric-unit">V</span>
              </div>
            </div>
          </div>
          <div class="metric-divider"></div>
          <div class="metric-block">
            <div class="metric-icon-wrap">
              <span class="current-icon-letter">A</span>
            </div>
            <div class="metric-body">
              <span class="metric-label">电流</span>
              <div class="metric-value-row">
                <span class="metric-value">{{ curr != null ? curr.toFixed(2) : '--' }}</span>
                <span class="metric-unit">A</span>
              </div>
            </div>
          </div>
          <div class="metric-divider"></div>
          <div class="metric-block">
            <div class="metric-icon-wrap">
              <span class="iconfont icon-nenghaotongji"></span>
            </div>
            <div class="metric-body">
              <span class="metric-label">功率</span>
              <div class="metric-value-row">
                <span class="metric-value">{{ power != null ? power.toFixed(2) : '--' }}</span>
                <span class="metric-unit">W</span>
              </div>
            </div>
          </div>
        </div>

        <div class="settings-list">
          <div class="settings-item" @click="toggleOutput">
            <span class="item-label">
              <span class="iconfont icon-kaiguan menu-icon"></span>
              电源开关
            </span>
            <van-switch v-model="outBool" :disabled="devdata.status !== '在线' || sending" size="22" @change="onOutChange" />
          </div>
          <div class="settings-item" @click="openDly">
            <span class="item-label">
              <span class="iconfont icon-gongzuomoshi menu-icon"></span>
              延时开关
            </span>
            <span class="item-value" :class="dlyItemClass">{{ dlyText }}</span>
          </div>
          <div class="settings-item" @click="gotoConfig">
            <span class="item-label">
              <span class="iconfont icon-sinaweibo18 menu-icon"></span>
              参数设置
            </span>
            <van-icon name="arrow" color="#98a2b3" size="16" />
          </div>
          <div class="settings-item" @click="gotoLog">
            <span class="item-label">
              <span class="iconfont icon-rizhi menu-icon"></span>
              历史日志
            </span>
            <van-icon name="arrow" color="#98a2b3" size="16" />
          </div>
        </div>

        <van-popup v-model="dlyShow" position="bottom" round class="dly-popup">
          <div class="dly-popup-title">延时开关</div>
          <van-radio-group v-model="dlyMode" direction="horizontal" class="dly-mode">
            <van-radio :name="1">延时关闭</van-radio>
            <van-radio :name="2">延时开启</van-radio>
          </van-radio-group>
          <div class="dly-mode-tip">{{ dlyMode === 1 ? '立即开启输出，倒计时结束后关闭' : '立即关闭输出，倒计时结束后开启' }}</div>
          <van-picker
            ref="dlyPicker"
            :show-toolbar="false"
            :columns="dlyColumns"
            visible-item-count="5"
            item-height="40"
            class="dly-picker"
          />
          <van-button type="primary" block round :disabled="sending" class="dly-start-btn" @click="startDly">启动延时</van-button>
        </van-popup>

        <VoltCurrChart :did="did" />
      </div>
      </van-pull-refresh>
    </div>
  </template>

<script>
import VoltCurrChart from "../echarts/VoltCurrChartKS1.vue";

export default {
  name: "DevPageKS1",
  components: {
    VoltCurrChart,
  },
  data() {
    return {
      devdata: null,
      did: this.$route.query.did,
      isLoading: false,
      sending: false,
      client: null,

      /* 延时开关 */
      dlyShow: false,
      dlyMode: 1,
      dlyRecvAt: 0,
      dlyLeftServer: 0,
      tick: 0,
      tickTimer: null,
    };
  },
  computed: {
    out() {
      return this.devdata && this.devdata.action ? this.devdata.action.out : 0;
    },
    dlyAct() {
      return this.devdata && this.devdata.action ? (this.devdata.action.dly_act || 0) : 0;
    },
    dlyColumns() {
      const col = (n, unit) => Array.from({ length: n }, (_, i) => String(i).padStart(2, "0") + " " + unit);
      return [
        { values: col(24, "时") },
        { values: col(60, "分") },
        { values: col(60, "秒") },
      ];
    },
    dlyRemain() {
      void this.tick;
      if (!this.dlyAct || !this.dlyRecvAt) return 0;
      const passed = (Date.now() - this.dlyRecvAt) / 1000;
      return Math.max(0, Math.round(this.dlyLeftServer - passed));
    },
    dlyText() {
      if (!this.dlyAct) return "未启动";
      return (this.dlyAct === 1 ? "延时关闭中 " : "延时开启中 ") + this.fmtHMS(this.dlyRemain);
    },
    dlyItemClass() {
      if (!this.dlyAct) return "item-value--muted";
      return "item-value--warn";
    },
    outBool: {
      get() {
        return this.out === 1;
      },
      set(val) {
        // handled by onOutChange
      },
    },
    volt() {
      return this.devdata && this.devdata.value ? this.devdata.value.volt : null;
    },
    curr() {
      return this.devdata && this.devdata.value ? this.devdata.value.curr : null;
    },
    power() {
      if (this.volt == null || this.curr == null) return null;
      return this.volt * this.curr;
    },
    anom() {
      return this.devdata && this.devdata.config ? this.devdata.config.anom : 0;
    },
    anomBool: {
      get() {
        return this.anom === 1;
      },
      set(val) {
        // handled by onAnomChange
      },
    },
    statusClass() {
      if (!this.devdata) return 'status-off';
      if (this.devdata.status === '离线') return 'status-off';
      if (this.devdata.err && this.devdata.err[0] !== 0) return 'status-warn';
      return this.out === 1 ? 'status-on' : 'status-standby';
    },
    statusBtnClass() {
      if (this.statusClass === 'status-warn') return 'status-button--warn';
      if (this.statusClass === 'status-off') return 'status-button--off';
      return this.out === 1 ? 'status-button--on' : 'status-button--standby';
    },
    statusTitle() {
      if (this.statusClass === 'status-warn') return '设备异常';
      if (this.statusClass === 'status-off') return '设备离线';
      return this.out === 1 ? '输出开启' : '输出关闭';
    },
    statusSub() {
      if (this.statusClass === 'status-warn') return '请检查电压电流状态';
      if (this.statusClass === 'status-off') return '设备当前不在线';
      return this.out === 1 ? '设备运行正常' : '待机中';
    },
    updateTimeText() {
      if (!this.devdata || !this.devdata.update_time) return '';
      const t = this.devdata.update_time;
      if (typeof t === 'string') return '更新于 ' + t;
      return '';
    },
  },
  mounted() {
    this.GetDevData(this.did);
    this.connectMqtt();
    this.tickTimer = setInterval(() => { this.tick++; }, 1000);
  },
  beforeDestroy() {
    if (this.tickTimer) { clearInterval(this.tickTimer); this.tickTimer = null; }
    this.disconnectMqtt();
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    GetDevData(did) {
      const qs = require("qs");
      this.$axios
        .post("/api/dev/one", qs.stringify({ did: did }))
        .then((response) => {
          if (response.data.error_code === 0) {
            this.devdata = response.data;
          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          }
        })
        .catch(() => { });
    },
    onReflash() {
      this.devrefresh();
    },
    devrefresh() {
      this.isLoading = true;
      const qs = require("qs");
      var databuf = JSON.stringify({ a: 2 });
      this.$axios
        .post("/api/dev/easy_mqtt_config", qs.stringify({
          did: this.devdata.did,
          d_type: "KS-1",
          config: databuf,
        }))
        .then((response) => {
          this.isLoading = false;
          if (response.data.error_code === 0) {
            this.GetDevData(this.did);
          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          }
        })
        .catch(() => { this.isLoading = false; });
    },
    toggleOutput() {
      if (this.sending || this.devdata.status !== '在线') return;
      this.outBool = !this.outBool;
    },
    onOutChange(val) {
      this.sendConfig({ out: val ? 1 : 0 }, "设置成功");
    },
    toggleAnom() {
      if (this.sending) return;
      this.anomBool = !this.anomBool;
    },
    onAnomChange(val) {
      this.sendConfig({ anom: val ? 1 : 0 }, "设置成功");
    },
    sendConfig(buf, successMsg) {
      if (this.sending) return;
      this.sending = true;
      const qs = require("qs");
      this.$axios
        .post("/api/dev/easy_mqtt_config", qs.stringify({
          did: this.did,
          d_type: "KS-1",
          config: JSON.stringify(buf),
        }))
        .then((response) => {
          this.sending = false;
          if (response.data.error_code === 0) {
            this.$toast.success(successMsg || "设置成功");
            this.GetDevData(this.did);
          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          } else {
            this.$toast.fail("设置失败");
          }
        })
        .catch(() => {
          this.sending = false;
          this.$toast.fail("设置失败");
        });
    },
    gotoConfig() {
      this.$router.push({ name: "KS1Config", query: { did: this.did, udname: this.devdata ? this.devdata.udname : '' } });
    },
    fmtHMS(totalSec) {
      const s = Math.max(0, Number(totalSec) || 0);
      const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      const p = (v) => String(v).padStart(2, "0");
      return `${p(h)}:${p(m)}:${p(sec)}`;
    },
    openDly() {
      if (this.devdata.status !== '在线') { this.$toast("设备离线"); return; }
      if (this.dlyAct) {
        this.$dialog.confirm({
          title: "延时进行中",
          message: "剩余 " + this.fmtHMS(this.dlyRemain) + "，是否取消延时？",
        }).then(() => { this.cancelDly(); }).catch(() => { });
        return;
      }
      this.dlyShow = true;
      this.$nextTick(() => {
        const picker = this.$refs.dlyPicker;
        picker && picker.setIndexes([0, 0, 0]);
      });
    },
    startDly() {
      const picker = this.$refs.dlyPicker;
      const idx = picker ? picker.getIndexes() : [0, 0, 0];
      const h = idx[0] || 0, m = idx[1] || 0, s = idx[2] || 0;
      if (h + m + s <= 0) { this.$toast("请选择延时时间"); return; }
      this.sendConfig({ dly: [this.dlyMode, h, m, s] }, "延时已启动");
      this.dlyShow = false;
    },
    cancelDly() {
      this.sendConfig({ dly: [0, 0, 0, 0] }, "延时已取消");
      this.dlyShow = false;
    },
    gotoLog() {
      this.$router.push({ name: "KS1Log", query: { did: this.did, udname: this.devdata ? this.devdata.udname : '' } });
    },
    connectMqtt() {
      if (typeof mqtt === "undefined") return;
      const topic = `kd/dev/KS-1/${this.did}/d2s`;
      try {
        this.client = mqtt.connect("wss://dev.kudutech.cn/mqtt", {
          clientId: "ks1_web_" + this.did + "_" + Math.random().toString(16).substr(2, 8),
          username: "KS-1dev",
          password: "KS-1dp",
          clean: true,
          reconnectPeriod: 5000,
        });
        this.client.on("connect", () => {
          this.client.subscribe(topic, { qos: 1 }, (err) => {
            if (err) console.log("KS-1 subscribe err", err);
          });
        });
        this.client.on("message", (topic, message) => {
          try {
            const data = JSON.parse(message.toString());
            if (!this.devdata) return;
            if (data.value) this.$set(this.devdata, "value", data.value);
            if (data.action) {
              this.$set(this.devdata, "action", data.action);
              if (data.action.dly_act) {
                this.dlyRecvAt = Date.now();
                this.dlyLeftServer = data.action.dly_left || 0;
              }
            }
            if (data.config) this.$set(this.devdata, "config", data.config);
            if (data.err) this.$set(this.devdata, "err", data.err);
          } catch (e) {
            console.log("KS-1 mqtt parse err", e);
          }
        });
      } catch (e) {
        console.log("KS-1 mqtt connect err", e);
      }
    },
    disconnectMqtt() {
      if (this.client) {
        try { this.client.end(); } catch (e) { }
        this.client = null;
      }
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Noto+Sans+SC:wght@400;500;600;700&display=swap");

.crystal-nav {
  background: #ffffff !important;
  border-bottom: 1px solid #f1f5f9;
}

.nav-title-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.3;
}

.nav-devname {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}

.nav-did {
  font-size: 11px;
  color: #94a3b8;
}

:deep(.van-switch--on) {
  background: #2dd4bf !important;
}
</style>

<style scoped>
.devpage-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: linear-gradient(145deg, #f0f9ff 0%, #fdf2f8 35%, #f0fdf4 100%);
  font-family: "Inter", "Noto Sans SC", sans-serif;
}

.devpage-index {
  background: transparent !important;
  padding-bottom: 20px;
  min-height: 100vh;
  min-height: 100dvh;
}

.content-area {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* ── Status Button ── */
.status-button {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 28px 20px;
  border-radius: 18px;
  color: #fff;
  cursor: pointer;
  transition: transform 0.15s, box-shadow 0.3s;
}

.status-button:active {
  transform: scale(0.97);
}

.status-button--on {
  background: linear-gradient(135deg, #2dd4bf 0%, #14b8a6 100%);
  box-shadow: 0 4px 16px rgba(45, 212, 191, 0.3);
}

.status-button--standby {
  background: linear-gradient(135deg, #94a3b8 0%, #64748b 100%);
  box-shadow: 0 4px 16px rgba(100, 116, 139, 0.2);
}

.status-button--off {
  background: linear-gradient(135deg, #cbd5e1 0%, #94a3b8 100%);
  cursor: not-allowed;
  box-shadow: 0 2px 12px rgba(148, 163, 184, 0.15);
}

.status-button--warn {
  background: linear-gradient(135deg, #fb7185 0%, #e11d48 100%);
  box-shadow: 0 4px 20px rgba(225, 29, 72, 0.3);
  animation: warnPulse 2s ease-in-out infinite;
}

@keyframes warnPulse {
  0%, 100% { box-shadow: 0 4px 20px rgba(225, 29, 72, 0.3); }
  50% { box-shadow: 0 4px 30px rgba(225, 29, 72, 0.5); }
}

.status-side-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.status-side-icon .iconfont {
  font-size: 22px;
}

.status-center {
  flex: 1;
  min-width: 0;
}

.status-title {
  font-size: 18px;
  font-weight: 700;
}

.status-subtitle {
  font-size: 12px;
  opacity: 0.85;
  margin-top: 2px;
}

.status-badge {
  width: 10px;
  height: 10px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.badge-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: block;
}

.dot-on {
  background: #fff;
  box-shadow: 0 0 8px rgba(255, 255, 255, 0.6);
  animation: dotGlow 2s ease-in-out infinite;
}

.dot-off {
  background: rgba(255, 255, 255, 0.4);
}

@keyframes dotGlow {
  0%, 100% { box-shadow: 0 0 8px rgba(255, 255, 255, 0.4); }
  50% { box-shadow: 0 0 14px rgba(255, 255, 255, 0.8); }
}

/* ── Unified Metrics Panel ── */
.metrics-panel {
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.04);
  display: flex;
  align-items: stretch;
  padding: 18px 6px;
}

.metric-block {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
}

.metric-icon-wrap {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(45, 212, 191, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.metric-icon-wrap .iconfont {
  font-size: 18px;
  color: #2dd4bf;
}

.current-icon-letter {
  font-weight: 700;
  font-size: 16px;
  color: #2dd4bf;
  line-height: 1;
}

.metric-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.metric-label {
  font-size: 12px;
  color: #94a3b8;
  font-weight: 500;
}

.metric-value-row {
  display: flex;
  align-items: baseline;
  gap: 2px;
}

.metric-value {
  font-size: 28px;
  font-weight: 700;
  color: #1e293b;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}

.metric-unit {
  font-size: 13px;
  color: #94a3b8;
  font-weight: 500;
}

.metric-divider {
  width: 1px;
  align-self: stretch;
  background: linear-gradient(180deg, transparent 10%, #e2e8f0 30%, #e2e8f0 70%, transparent 90%);
  flex-shrink: 0;
  margin: 4px 0;
}

/* ── Settings List ── */
.settings-list {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

.settings-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  cursor: pointer;
  transition: background 0.15s;
}

.settings-item:active {
  background: #f8fafc;
}

.settings-item + .settings-item {
  border-top: 1px solid #f1f5f9;
}

/* ── 延时开关 ── */
.item-value {
  font-size: 13px;
  font-weight: 500;
  color: #94a3b8;
}

.item-value--muted {
  color: #94a3b8;
}

.item-value--warn {
  color: #fb7185;
  font-variant-numeric: tabular-nums;
}

.dly-popup {
  width: 92%;
  max-width: 400px;
  padding: 20px 16px 24px;
  box-sizing: border-box;
}

.dly-popup-title {
  font-size: 16px;
  font-weight: 700;
  color: #1e293b;
  text-align: center;
  margin-bottom: 14px;
}

.dly-mode {
  justify-content: center;
  margin-bottom: 6px;
}

.dly-mode-tip {
  text-align: center;
  font-size: 12px;
  color: #94a3b8;
  margin-bottom: 16px;
}

.dly-picker {
  margin-bottom: 16px;
}

.dly-picker .van-picker__columns {
  width: 80%;
  margin: 0 auto;
}

.dly-start-btn {
  background: linear-gradient(135deg, #2dd4bf, #14b8a6);
  border: none;
  font-weight: 600;
}

.item-label {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 500;
  color: #475569;
}

.item-label .menu-icon {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: rgba(45, 212, 191, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 16px;
  color: #2dd4bf;
}
</style>
